/* ============================================
   FAQ Page JavaScript - Surebeauty
   ============================================ */

function faqToggle(el) {
  var item = el.parentElement;
  var answer = item.querySelector('.faq-a');
  var inner = item.querySelector('.faq-a-inner');
  var isOpen = item.classList.contains('open');

  // Close all
  document.querySelectorAll('.faq-item.open').forEach(function(openItem) {
    openItem.classList.remove('open');
    openItem.querySelector('.faq-a').style.maxHeight = null;
  });

  // Toggle clicked
  if (!isOpen) {
    item.classList.add('open');
    answer.style.maxHeight = inner.scrollHeight + 40 + 'px';
  }
}

function faqFilter(cat, btn) {
  // Update active button
  document.querySelectorAll('.faq-cat').forEach(function(b) { b.classList.remove('active'); });
  if (btn) btn.classList.add('active');

  // Show/hide sections and items
  var sections = document.querySelectorAll('.faq-section');
  if (cat === 'all') {
    sections.forEach(function(s) { s.style.display = ''; });
    document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('hidden-by-filter'); });
  } else {
    sections.forEach(function(s) {
      s.style.display = s.id === 'sec-' + cat ? '' : 'none';
    });
    document.querySelectorAll('.faq-item').forEach(function(i) {
      var cats = i.getAttribute('data-cats') || '';
      if (cats.indexOf(cat) !== -1) {
        i.classList.remove('hidden-by-filter');
      } else {
        i.classList.add('hidden-by-filter');
      }
    });
  }

  // Close all open items
  document.querySelectorAll('.faq-item.open').forEach(function(openItem) {
    openItem.classList.remove('open');
    openItem.querySelector('.faq-a').style.maxHeight = null;
  });
}

function faqSearchAction() {
  var query = document.getElementById('faqSearch').value.toLowerCase().trim();
  if (!query) {
    // Reset
    document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('hidden-by-filter'); });
    document.querySelectorAll('.faq-section').forEach(function(s) { s.style.display = ''; });
    document.querySelectorAll('.faq-cat').forEach(function(b) { b.classList.remove('active'); });
    var allBtn = document.querySelector('.faq-cat[data-cat="all"]');
    if (allBtn) allBtn.classList.add('active');
    return;
  }

  // Filter items
  document.querySelectorAll('.faq-section').forEach(function(s) { s.style.display = ''; });
  document.querySelectorAll('.faq-cat').forEach(function(b) { b.classList.remove('active'); });

  document.querySelectorAll('.faq-item').forEach(function(i) {
    var qText = i.querySelector('.faq-q').textContent.toLowerCase();
    var aText = i.querySelector('.faq-a-inner').textContent.toLowerCase();
    if (qText.indexOf(query) !== -1 || aText.indexOf(query) !== -1) {
      i.classList.remove('hidden-by-filter');
      // Auto-expand matching items
      if (!i.classList.contains('open')) {
        i.classList.add('open');
        var answer = i.querySelector('.faq-a');
        var inner = i.querySelector('.faq-a-inner');
        answer.style.maxHeight = inner.scrollHeight + 40 + 'px';
      }
    } else {
      i.classList.add('hidden-by-filter');
    }
  });

  // Hide empty sections
  document.querySelectorAll('.faq-section').forEach(function(s) {
    var visible = s.querySelectorAll('.faq-item:not(.hidden-by-filter)');
    if (visible.length === 0) {
      s.style.display = 'none';
    }
  });
}

// Search on Enter key
document.addEventListener('DOMContentLoaded', function() {
  var searchInput = document.getElementById('faqSearch');
  if (searchInput) {
    searchInput.addEventListener('keyup', function(e) {
      if (e.key === 'Enter') {
        faqSearchAction();
      }
      // Live filter as typing (with debounce)
      clearTimeout(window._faqSearchTimeout);
      window._faqSearchTimeout = setTimeout(function() {
        faqSearchAction();
      }, 300);
    });
  }
});
